import { expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';
import React, { useEffect, useState } from 'react'
import configData from "../../../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput,
    Modal, ModalBody, ModalFooter
} from 'reactstrap';
import Table from 'react-bootstrap/Table'

import Megafono from "assets/icons/megafono.png"
import "./FormularioGastosPersonales.scss"

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardFormularioGastosPersonales from "components/Varios/CardFormularioGastosPersonales.js";
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { Link } from "react-router-dom";
import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../../../services/authentication.service';
import PDFViewer from '../../Varios/PDFViewer';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';

const id = 1043;
const API_URL = configData.SERVER_URL;
let tieneRestriccion = false;

export const MensajeEncabezado = <span>&nbsp;Antes de realizar el formulario recuerde actualizar su información del núcleo familiar, <a href="/admin/informacion-familiar">aquí</a>.</span>
export const MensajeEncabezado2 = <span><strong>Recuerde que para el registro de padres como cargas familiares, deberán presentar su consentimiento con fecha actualizada.</strong></span>
export const MensajePopup = <span>&nbsp;<strong>Si desea añadir o modificar sus cargas familiares, <a href="/admin/informacion-familiar">click aquí</a>.</strong></span>
export const MensajeValidacionCargas = <span>&nbsp;Si usted mantiene cargas pendientes de validar, dar clic en 'Enviar a validación de TH'.Una vez validada la carga, podrá continuar con el formulario de gastos personales.</span>

export class FormularioGastosPersonalesData {
    idotrosdocumentos: number = 0;
    idpersona: number = 0;
    tipodoc: string = "";
    codigodocumento: string = "";
    refarchivo: string = "";
    refarchivo3: string = "";
    fecharegistro: string = "";
    estado: string = "";
    estadon: string = "";
    estadorevisionth: number = 0;

    anio: number = 0;
    ingresosempleador: number = 0;
    ingresosotroempleador: number = 0;
    vivienda: number = 0;
    educacion: number = 0;
    salud: number = 0;
    vestimenta: number = 0;
    alimentacion: number = 0;
    turismo: number = 0;
    totalingresos: number = 0;
    totalgatos: number = 0;
    rebaja: number = 0;
    idgastopersonalcab: number = 0;
}

export class FormularioGastosPersonalesFechas {
    fechadesde: string = "";
    fechahasta: string = "";
}

interface FormularioGastosPersonalesDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: FormularioGastosPersonalesData;
    FormularioGastosPersonalesList: FormularioGastosPersonalesData[];
    tipoSolicitudList: Array<any>;
    GastosPersonalesList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    dtoFechas: FormularioGastosPersonalesFechas;
    showDiv: boolean;
    isOpenModal: boolean;
    CargasList: Array<any>;
    isOpenConfirmacion: boolean;
    showModalAplicarDescuento: boolean;
    urlAplicarDescuento: string;
}

export class FormularioGastosPersonales extends React.Component<RouteComponentProps, FormularioGastosPersonalesDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new FormularioGastosPersonalesData(),
            FormularioGastosPersonalesList: [], tipoSolicitudList: [], GastosPersonalesList: [], error: null, tiposEvidencia: [], filesData: [], dtoFechas: new FormularioGastosPersonalesFechas(),
            showDiv: false, isOpenModal: false, CargasList: [], isOpenConfirmacion: false, showModalAplicarDescuento: false, urlAplicarDescuento: ""
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarSolicitudAcumulaDecimos = this.cargarSolicitudAcumulaDecimos.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
        this.cargarFechas = this.cargarFechas.bind(this);
        this.vistPreviaAplicarDescuento = this.vistPreviaAplicarDescuento.bind(this);
    }

    componentDidMount() {
        window.location.href = "https://th.espol.edu.ec/user/informacion-laboral/pagos";
        //authenticationService.currentUser.subscribe(
        //    (x) => {
        //        this.setState({
        //            currentUser: x
        //        });
        //        if (x && x.token) {
        //            this.cargarFechas();
        //            this.cargarDatos();
        //            this.cargarSolicitudAcumulaDecimos();
        //        }
        //    }
        //);
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        if (!expresion_civil(authenticationService.currentUserValue.regimen_usuario))
            tieneRestriccion = true;

        fetch(API_URL + "SolicitudAcumulaDecimos/SolicitudAcumulaDecimosCatalogo")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoSolicitudList: result.entTabla.map(d => ({
                                "value": d.codigodocumento,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tipoSolicitudList: []
                    });
                    alertService.error("Ha ocurrido un evento inesperado: " + error)
                }
            )
    }

    cargarSolicitudAcumulaDecimos() {
        this.setState({
            loading: false,
            loadingList: false
        });
        fetch(API_URL + "FormularioGastosPersonales/FormularioGastosPersonalesDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            FormularioGastosPersonalesList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        FormularioGastosPersonalesList: []
                    });
                    alertService.error("Ha ocurrido un evento inesperado: " + error)
                }
            )
    }

    cargarFechas() {
        fetch(API_URL + "FormularioGastosPersonales/FormularioGastosPersonalesFechas")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let _dtoFechas = new FormularioGastosPersonalesFechas();
                        _dtoFechas["fechadesde"] = result.entTabla[0].fechadesde;
                        _dtoFechas["fechahasta"] = result.entTabla[0].fechahasta;

                        if ((new Date()).getTime() > (new Date(result.entTabla[0].fechahasta + "T23:59:59")).getTime())
                            alertService.error("El período de ingreso de datos en esta opción no está disponible.");

                        this.setState({
                            dtoFechas: _dtoFechas
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tipoSolicitudList: []
                    });
                    alertService.error("Ha ocurrido un evento inesperado: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleChange2 = (e, index) => {
        var dto = this.state.CargasList;
        const { name, value } = e.target;
        const list = [...dto];
        list[index]["strconsiderar"] = value;
        this.setState({ CargasList: dto });

        this.validarbotonescargas();
    }
    validarbotonescargas() {
        var bandera = false;
        var banderadocumento = false;
        if (this.state.CargasList.length > 0) {
            this.state.CargasList.map((infoDetalle, indiceinfoDetalle) => {
                if (infoDetalle.strconsiderar && infoDetalle.strconsiderar === "S" && (infoDetalle.estadorevisionth === "N" || infoDetalle.estadorevisionth === "R")) {
                    bandera = true;
                }
                if (infoDetalle.strconsiderar && infoDetalle.strconsiderar === "S" && (infoDetalle.idparentesco == 1 || infoDetalle.idparentesco == 2)) {
                    if (!infoDetalle.refarchivoconsentimiento) banderadocumento = true;
                }
            });
            if (bandera) {
                if (banderadocumento) {
                    var btnvalidacion = document.getElementById("btnvalidacion");
                    if (btnvalidacion != null) {
                        btnvalidacion.style.display = 'none';
                    }
                }
                else {
                    var btnvalidacion = document.getElementById("btnvalidacion");
                    if (btnvalidacion != null) {
                        btnvalidacion.style.display = 'initial';
                    }
                }

                var btncontinuar = document.getElementById("btncontinuar");
                if (btncontinuar != null) {
                    btncontinuar.style.display = 'none';
                }
            }
            else {
                var btnvalidacion = document.getElementById("btnvalidacion");
                if (btnvalidacion != null) {
                    btnvalidacion.style.display = 'none';
                }

                var btncontinuar = document.getElementById("btncontinuar");
                if (btncontinuar != null) {
                    btncontinuar.style.display = 'initial';
                }
            }

            var divvalidacionmostrar = false;
            this.state.CargasList.map((dtox, indice) => {
                if (dtox.strconsideraranioactual && dtox.strconsideraranioactual === "V") divvalidacionmostrar = true
            });
            if (divvalidacionmostrar) {
                var btnvalidacion = document.getElementById("btnvalidacion");
                if (btnvalidacion != null) {
                    btnvalidacion.style.display = 'none';
                }
                var btncontinuar = document.getElementById("btncontinuar");
                if (btncontinuar != null) {
                    btncontinuar.style.display = 'none';
                }
            }
        }
        else {
            var btnvalidacion = document.getElementById("btnvalidacion");
            if (btnvalidacion != null) {
                btnvalidacion.style.display = 'none';
            }

            var btncontinuar = document.getElementById("btncontinuar");
            if (btncontinuar != null) {
                btncontinuar.style.display = 'initial';
            }
        }
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        if (name == "codigodocumento")
            dto["tipodoc"] = value;

        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });
    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "IDI", "label": "" + filesData.filter(f => f.type == "IDI").map(ff => ': ' + ff.file.name).join(', ') },
        ];
        return tiposEvidencia;
    }

    descargarEvidencias(formularioformulario: FormularioGastosPersonalesData) {
        var evidencias = new Array();
        if (formularioformulario.refarchivo) {
            evidencias.push({ name: "GP-" + this.state.currentUser.identificacion + "-" + formularioformulario.anio + ".PDF", url: API_URL + "SolicitudAcumulaDecimos/Refarchivo/" + formularioformulario.idotrosdocumentos, tipo: "Formulario" });
        }
        if (formularioformulario.refarchivo3) {
            evidencias.push({ name: "GP-" + this.state.currentUser.identificacion + "-" + formularioformulario.anio + ".PDF", url: API_URL + "FormularioGastosPersonales/RefarchivoCarta/" + formularioformulario.refarchivo3, tipo: "Carta" });
        }
        return evidencias;
    }

    onClickLimpiar() {
        //this.setState({
        //    isOpenModal: false
        //});
        //this.setState({ dtoData: new FormularioGastosPersonalesData() });
        //this.setState({
        //    loading: false,
        //    loadingList: false
        //});




        var dto = this.state.CargasList;

        var bandera = false;
        this.state.CargasList.map((infoDetalle, indiceinfoDetalle) => {
            if (infoDetalle.strconsiderar && infoDetalle.strconsiderar === "S" && infoDetalle.estadorevisionth != "S")
                bandera = true;
        });

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (!bandera) {
            fetch(API_URL + "FormularioGastosPersonales/PostCargasRegistradass", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error(" " + responseJson["strMensaje"])

                            this.setState({
                                isOpenModal: false,
                                isOpenConfirmacion: false
                            });
                        }
                        else if (responseJson["strEstado"] === "S") {

                            this.setState({
                                isOpenModal: false,
                                isOpenConfirmacion: false
                            });
                            this.setState({ dtoData: new FormularioGastosPersonalesData() });
                            this.setState({
                                loading: false,
                                loadingList: false
                            });




                            fetch(API_URL + "FormularioGastosPersonales/NuevoFormularioGastosPersonalesByIdpersona/" + this.state.currentUser.idpersona)
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                        if (result.strEstado === "S") {
                                            this.setState({
                                                GastosPersonalesList: result.entTabla,
                                                loading: false,
                                                loadingList: false,
                                                showDiv: true
                                            });
                                        } else {
                                            alertService.error(" " + result.strMensaje);
                                        }
                                    },
                                    (error) => {
                                        this.setState({
                                            loading: false,
                                            error,
                                            GastosPersonalesList: []
                                        });
                                        alertService.error("Ha ocurrido un evento inesperado: " + error)
                                    }
                                )


                        }
                        else {
                            alertService.error(" " + responseJson)

                            this.setState({
                                isOpenModal: false,
                                isOpenConfirmacion: false
                            });
                        }
                    },
                    (error) => {
                        alertService.error("Ha ocurrido un evento inesperado: " + error);
                    })
        }
        else
            alertService.error("Todas las cargas deben estar validadas por Talento Humano");

    }

    onClickEdit(idgastopersonalcab) {
        fetch(API_URL + "FormularioGastosPersonales/FormularioGastosPersonalesById/" + idgastopersonalcab)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            GastosPersonalesList: result.entTabla,
                            loading: false,
                            showDiv: true
                        });

                        

                        result.entTabla.map((dto, indice) => {
                            if (dto["descripcion"].includes("OTROS EMPLEADORES") && dto["tipo"] == "I" && +dto["valor"] > 0) {

                                var row_aplicadescuento = document.getElementById("row_aplicadescuento");
                                if (row_aplicadescuento != null) {
                                    row_aplicadescuento.className = "rows_tabla_planificacion_vac";
                                }

                                var aplicardescuento_si = document.getElementById("aplicardescuento_si");
                                if (aplicardescuento_si != null) {
                                    aplicardescuento_si.removeAttribute("disabled");
                                }
                                var aplicardescuento_no = document.getElementById("aplicardescuento_no");
                                if (aplicardescuento_no != null) {
                                    aplicardescuento_no.removeAttribute("disabled");
                                }
                            };
                        });

                        result.entTabla.map((dto, indice) => {
                            if (dto["descripcion"].includes("APLICARME DESCUENTO") && dto["valor"] === "1") {
                                var aplicardescuento_no = document.getElementById("aplicardescuento_no");
                                if (aplicardescuento_no != null) {
                                    //aplicardescuento_no.setAttribute("checked", "true");
                                    aplicardescuento_no.click();
                                }

                                var btnpreviewaplicardescuento = document.getElementById("btnpreviewaplicardescuento");
                                if (btnpreviewaplicardescuento != null) {
                                    btnpreviewaplicardescuento.className = "btn btn-sm btn-default";
                                }
                            };
                            if (dto["descripcion"].includes("APLICARME DESCUENTO") && dto["valor"] === "0") {
                                var aplicardescuento_si = document.getElementById("aplicardescuento_si");
                                if (aplicardescuento_si != null) {
                                    //aplicardescuento_si.setAttribute("checked", "true");
                                    aplicardescuento_si.click();
                                }
                            };
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error
                    });
                    alertService.error("Ha ocurrido un evento inesperado: " + error)
                }
            )
    }

    onClickAceptar() {
        //event.preventDefault();
        var dto = this.state.GastosPersonalesList;
        let formIsValid = true;
        let errors = "";

        //forma.forEach((value, clave) => {
        //    if (!value && clave !== "evidencias") {
        //        formIsValid = false;
        //        errors = "Por favor seleccione todos los campos. "
        //    }

        //    if (typeof dto[clave] === 'number') {
        //        dto[clave] = Number(value);
        //    }
        //    else if (typeof dto[clave] === 'boolean') {
        //        dto[clave] = Boolean(value);
        //    }
        //    else
        //        dto[clave] = value;
        //});

        //dto.idpersona = this.state.currentUser.idpersona;
        //delete dto['fecharegistro'];

        var btnaceptar = document.getElementById("btnaceptar");
        const i = document.createElement("i");
        i.setAttribute("id", "loadingEnviar")
        i.setAttribute("class", "fa fa-spin fa-spinner")
        if (btnaceptar != null) {
            btnaceptar.textContent = " Cargando . . . ";
            btnaceptar.insertBefore(i, null)
            btnaceptar.setAttribute("disabled", "true");
        }

        var btnguardar = document.getElementById("btnguardar");
        i.setAttribute("id", "loadingEnviar")
        i.setAttribute("class", "fa fa-spin fa-spinner")
        if (btnguardar != null) {
            btnguardar.textContent = " Cargando . . . ";
            btnguardar.insertBefore(i, null)
            btnguardar.setAttribute("disabled", "true");
        }

        var btncancelar = document.getElementById("btncancelar");
        i.setAttribute("id", "loadingEnviar")
        i.setAttribute("class", "fa fa-spin fa-spinner")
        if (btncancelar != null) {
            btncancelar.textContent = " Cargando . . . ";
            btncancelar.insertBefore(i, null)
            btncancelar.setAttribute("disabled", "true");
        }

        dto.map((dtox, indice) => {
            if (dtox["descripcion"].includes("APLICARME DESCUENTO") && dtox["valor"] === "1" && (!dtox["comentario"] || dtox["comentario"] === "")) {
                errors = "Ingrese el nombre de la institución con la que tiene relación de dependencia.";
                formIsValid = false;
            }
        });

        dto.map((dtox, indice) => { dtox["idpersona"] = this.state.currentUser.idpersona; });
        dto.map((dtox, indice) => { dtox["valor"] = '' + dtox["valor"]; dtox["valor"] = '' + dtox["valor"]; })

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
        //if (dto.idotrosdocumentos == 0) {
        fetch(API_URL + "FormularioGastosPersonales/PutFormularioGastosPersonalesById", {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: data,
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(" " + responseJson["strMensaje"])
                    }
                    else if (responseJson["strEstado"] === "S") {
                        alertService.success("Se ha enviado el formulario de Gastos Personales a la Dirección de Talento Humano.");

                        this.setState({
                            showDiv: false
                        });

                        this.cargarSolicitudAcumulaDecimos();
                        //this.onClickLimpiar();
                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    }
                    else {
                        alertService.error(" " + responseJson)
                    }

                    var btnaceptar = document.getElementById("btnaceptar");
                    if (btnaceptar != null) {
                        btnaceptar.textContent = "Aceptar y Enviar";
                        btnaceptar.removeAttribute("disabled");
                    }

                    var btnguardar = document.getElementById("btnguardar");
                    if (btnguardar != null) {
                        btnguardar.removeAttribute("disabled");
                    }

                    var btncancelar = document.getElementById("btncancelar");
                    if (btncancelar != null) {
                        btncancelar.removeAttribute("disabled");
                    }
                },
                (error) => {
                    alertService.error("Ha ocurrido un evento inesperado: " + error);

                    var btnaceptar = document.getElementById("btnaceptar");
                    if (btnaceptar != null) {
                        btnaceptar.textContent = "Aceptar y Enviar";
                        btnaceptar.removeAttribute("disabled");
                    }
                    var btnguardar = document.getElementById("btnguardar");
                    if (btnguardar != null) {
                        btnguardar.removeAttribute("disabled");
                    }

                    var btncancelar = document.getElementById("btncancelar");
                    if (btncancelar != null) {
                        btncancelar.removeAttribute("disabled");
                    }
                })
        //}
        }
        else {
            alertService.error("Ha ocurrido un evento inesperado: " + errors);

            var btnaceptar = document.getElementById("btnaceptar");
            if (btnaceptar != null) {
                btnaceptar.textContent = "Aceptar y Enviar";
                btnaceptar.removeAttribute("disabled");
            }
            var btnguardar = document.getElementById("btnguardar");
            if (btnguardar != null) {
                btnguardar.textContent = "Guardar";
                btnguardar.removeAttribute("disabled");
            }

            var btncancelar = document.getElementById("btncancelar");
            if (btncancelar != null) {
                btncancelar.textContent = "Cancelar";
                btncancelar.removeAttribute("disabled");
            }
        }
    }

    onClickCancelar() {
        this.setState({
            showDiv: false
        });
    }

    onClickDelete(idgastopersonalcab) {
        fetch(API_URL + "FormularioGastosPersonales/DeleteFormularioGastosPersonales/" + idgastopersonalcab, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("El formulario de Gastos Personales se anuló correctamente.")
                        this.cargarSolicitudAcumulaDecimos();
                    }
                })
    }

    handleChange4 = (e, index) => {
        var inputList = this.state.GastosPersonalesList;
        const { name, value } = e.target;
        const list = [...inputList];
        list[index]["comentario"] = value;
        this.setState({ GastosPersonalesList: inputList });
    }

    handleChange3 = (e, index) => {
        var inputList = this.state.GastosPersonalesList;
        //const { name, value } = e.target.value;
        const list = [...inputList];
        list[index]["valor"] = e.target.value;
        this.setState({ GastosPersonalesList: inputList });

        if (e.target.value && e.target.value === "1") {
            var txtaplicardescuento = document.getElementById("txtaplicardescuento");
            if (txtaplicardescuento != null) {
                txtaplicardescuento.removeAttribute("disabled");
            }
            var btnpreviewaplicardescuento = document.getElementById("btnpreviewaplicardescuento");
            if (btnpreviewaplicardescuento != null) {
                btnpreviewaplicardescuento.className = "btn btn-sm btn-default";
            }
        }
        else if (e.target.value && e.target.value === "0") {
            var txtaplicardescuento = document.getElementById("txtaplicardescuento");
            if (txtaplicardescuento != null) {
                txtaplicardescuento.setAttribute("disabled", "true");
            }
            var btnpreviewaplicardescuento = document.getElementById("btnpreviewaplicardescuento");
            if (btnpreviewaplicardescuento != null) {
                btnpreviewaplicardescuento.className = "btn btn-sm btn-default hide";
            }
        }
    }

    handleInputChange = (e, index) => {
        var inputList = this.state.GastosPersonalesList;
        const { name, value } = e.target;

        if (!(!value || value.match(/^\d{1,}(\.\d{0,2})?$/))) {
            return
        }

        const list = [...inputList];

        list[index][name] = value;

        var ingreso = 0;
        list.map((dto, indice) => { if (dto["tipo"] == "I") ingreso = +ingreso + +dto["valor"]; });

        var egreso = 0;
        list.map((dto, indice) => { if (dto["tipo"] == "G") egreso = +egreso + +dto["valor"]; });

        /* 2023 2 */
        var valormaximo = 0;
        list.map((dto, indice) => { if (dto["tipo"] == "R" && dto["descripcion"].includes("MÁXIMO")) valormaximo = +dto["valor"]; });
        var band_totalegreso = false;
        (+egreso > +valormaximo ? band_totalegreso = true : band_totalegreso = false);

        if (list[index]["tipo"] == "G" && +value > 0 && +value < +valormaximo) {
            if (!band_totalegreso) list[index][name] = value;
            else list[index][name] = 0;
        }
        else if (list[index]["tipo"] == "G" && +value > 0 && +value > +valormaximo) {
            list[index][name] = 0;
        }
        else if (list[index]["tipo"] == "I" && +value > 0) {
            list[index][name] = value;
        }

        if (list[index]["tipo"] == "I" && +value > 0 && list[index]["descripcion"].includes("OTROS EMPLEADORES")) {
            var row_aplicadescuento = document.getElementById("row_aplicadescuento");
            if (row_aplicadescuento != null) {
                row_aplicadescuento.className = "rows_tabla_planificacion_vac";
            }

            var aplicardescuento_si = document.getElementById("aplicardescuento_si");
            if (aplicardescuento_si != null) {
                aplicardescuento_si.removeAttribute("disabled");
            }
            var aplicardescuento_no = document.getElementById("aplicardescuento_no");
            if (aplicardescuento_no != null) {
                aplicardescuento_no.removeAttribute("disabled");
            }
        }
        else if (list[index]["tipo"] == "I" && +value === 0 && list[index]["descripcion"].includes("OTROS EMPLEADORES")) {
            var row_aplicadescuento = document.getElementById("row_aplicadescuento");
            if (row_aplicadescuento != null) {
                row_aplicadescuento.className = "rows_tabla_planificacion_vac hide";
            }

            var aplicardescuento_si = document.getElementById("aplicardescuento_si");
            if (aplicardescuento_si != null) {
                aplicardescuento_si.setAttribute("disabled", "true");
            }
            var aplicardescuento_no = document.getElementById("aplicardescuento_no");
            if (aplicardescuento_no != null) {
                aplicardescuento_no.setAttribute("disabled", "true");
            }
        }

        egreso = 0;
        list.map((dto, indice) => { if (dto["tipo"] == "G") egreso = +egreso + +dto["valor"]; });

        list.map((dto, indice) => { dto["idpersona"] = this.state.currentUser.idpersona; });

        list.map((dto, indice) => { if (dto["tipo"] == "0") dto["valor"] = ingreso.toFixed(2); })
        list.map((dto, indice) => { if (dto["tipo"] == "1" && dto["descripcion"].includes("TOTAL")) dto["valor"] = egreso.toFixed(2); })
        list.map((dto, indice) => { if (dto["tipo"] == "2" && dto["descripcion"].includes("REBAJA")) dto["valor"] = (egreso * 0.18).toFixed(2); })

        /* 2023 1
        var band_totalegreso = false;
        list.map((dto, indice) => { if (dto["tipo"] == "1" && dto["descripcion"].includes("TOTAL")) +egreso > +dto["valormaximo"] ? band_totalegreso = true : band_totalegreso = false; })
        if (list[index]["tipo"] == "G" && +value > 0 && +value < +(list[index]["valormaximo"])) {
            if (!band_totalegreso) list[index][name] = value;
            else list[index][name] = 0;
        }
        else if (list[index]["tipo"] == "G" && +value > 0 && +value > +(list[index]["valormaximo"])) {
            list[index][name] = 0;
        }
        else if (list[index]["tipo"] == "I" && +value > 0) list[index][name] = value;

        //var ingreso = 0;
        //list.map((dto, indice) => { if (dto["tipo"] == "I") ingreso = +ingreso + +dto["valor"]; });

        egreso = 0;
        list.map((dto, indice) => { if (dto["tipo"] == "G") egreso = +egreso + +dto["valor"]; });

        list.map((dto, indice) => { dto["idpersona"] = this.state.currentUser.idpersona; });

        list.map((dto, indice) => { if (dto["tipo"] == "0") dto["valor"] = ingreso.toFixed(2); })
        list.map((dto, indice) => { if (dto["tipo"] == "1" && dto["descripcion"].includes("TOTAL")) dto["valor"] = egreso.toFixed(2); })
        list.map((dto, indice) => { if (dto["tipo"] == "1" && dto["descripcion"].includes("REBAJA")) ingreso < dto["valormaximo"] ? dto["valor"] = (egreso * 0.2).toFixed(2) : dto["valor"] = (egreso * 0.1).toFixed(2); })
        */
        this.setState({ GastosPersonalesList: inputList });
    };

    handleDecimalsOnValue(value) {
        const regex = /([0-9]*[\.]{0,1}[0-9]{0,2})/s;
        return value.match(regex)[0];
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append("files", fileData.file, fileData.file.name);
            });

            formFilesData.append('identidad', identidad);
            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error al guardar las evidencias.")
                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("Las evidencias se cargaron exitosamente");
                        }
                    },
                    (error) => { alertService.error("Ocurrió un error al cargar las evidencias.") }
                );
        }
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.GastosPersonalesList;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        //if (filesData === undefined || filesData.length === 0) {
        //    alertService.error("Debe adjuntar evidencia de la cuenta bancaria")
        //    return;
        //}

        //forma.forEach((value, clave) => {
        //    if (!value && clave !== "evidencias") {
        //        formIsValid = false;
        //        errors = "Por favor seleccione todos los campos. "
        //    }

        //    if (typeof dto[clave] === 'number') {
        //        dto[clave] = Number(value);
        //    }
        //    else if (typeof dto[clave] === 'boolean') {
        //        dto[clave] = Boolean(value);
        //    }
        //    else
        //        dto[clave] = value;
        //});

        //dto.idpersona = this.state.currentUser.idpersona;
        //delete dto['fecharegistro'];
        dto.map((dtox, indice) => {
            if (dtox["descripcion"].includes("APLICARME DESCUENTO") && dtox["valor"] === "1" && (!dtox["comentario"] || dtox["comentario"] === "")) {
                errors = "Ingrese el nombre de la institución con la que tiene relación de dependencia.";
                formIsValid = false;
                return;
            };
        });


        dto.map((dtox, indice) => { dtox["idpersona"] = this.state.currentUser.idpersona; });
        dto.map((dtox, indice) => { dtox["valor"] = '' + dtox["valor"]; dtox["valor"] = '' + dtox["valor"]; })

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            //if (dto.idotrosdocumentos == 0) {
            fetch(API_URL + "FormularioGastosPersonales/PostFormularioGastosPersonalesByIdpersona", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error: " + responseJson)
                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("El formulario de Gastos Personales ha sido guardado, recuerde que debe enviar el documento a la Dirección de Talento Humano.");

                            this.setState({
                                showDiv: false
                            });

                            this.cargarSolicitudAcumulaDecimos();
                            //this.onClickLimpiar();
                            let myDiv = document.getElementById('main-panel')!;
                            myDiv.scrollTo(0, 0);
                        }
                        else {
                            alertService.error("Ha ocurrido un evento inesperado: " + responseJson["strMensaje"])
                        }
                    },
                    (error) => {
                        alertService.error("Ha ocurrido un evento inesperado: " + error)
                    })
            //}
        }
        else {
            alertService.error("Ha ocurrido un evento inesperado: " + errors);
        }
    }

    toggleConfirmacion = () => {
        this.setState({
            isOpenConfirmacion: !this.state.isOpenConfirmacion,
        });
    };
    toggle = () => {
        this.setState({
            isOpenConfirmacion: !this.state.isOpenConfirmacion,
        });
    };

    toggleAplicarDescuento = () => {
        this.setState({
            showModalAplicarDescuento: !this.state.showModalAplicarDescuento,
        });
    };

    showModal() {

        this.setState({
            showDiv: false
        });

        fetch(API_URL + "FormularioGastosPersonales/CargasRegistradas/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            CargasList: result.entTabla,
                            isOpenModal: true
                        });

                        if (this.state.CargasList.length > 0) {

                            var divvalidacionmostrar = false;
                            this.state.CargasList.map((dtox, indice) => {
                                if (dtox.strconsideraranioactual && dtox.strconsideraranioactual != "E" && dtox.strconsideraranioactual != "S" && dtox.strconsideraranioactual != "R") divvalidacionmostrar = true
                                else if (!dtox.strconsideraranioactual) divvalidacionmostrar = true
                            });
                            var divvalidacion = document.getElementById("divvalidacion");
                            if (divvalidacion != null && !divvalidacionmostrar) {
                                divvalidacion.style.display = 'none';
                            }

                            var btnvalidacion = document.getElementById("btnvalidacion");
                            if (btnvalidacion != null) {
                                btnvalidacion.style.display = 'none';
                            }

                            var btncontinuar = document.getElementById("btncontinuar");
                            if (btncontinuar != null) {
                                btncontinuar.style.display = 'none';
                            }
                        }
                        else {
                            var divvalidacion = document.getElementById("divvalidacion");
                            if (divvalidacion != null) {
                                divvalidacion.style.display = 'none';
                            }

                            var btnvalidacion = document.getElementById("btnvalidacion");
                            if (btnvalidacion != null) {
                                btnvalidacion.style.display = 'none';
                            }

                            var btncontinuar = document.getElementById("btncontinuar");
                            if (btncontinuar != null) {
                                btncontinuar.style.display = 'initial';
                            }
                        }

                    }
                    else if (result.strEstado === "N") {
                        alertService.error(" " + result.strMensaje);
                    }
                    else {
                        alertService.error("Ocurrió un error al obtener los datos.");
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error: " + error);
                }
            )
    }

    mostrarSeccionCargas() {

        return (
            <React.Fragment>
                <div className="content">

                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <div className={"new-alert-warn mb-1"}>
                                    <strong>Recuerde que para el registro de padres como cargas familiares, deberán presentar su consentimiento con fecha actualizada.</strong>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <span>
                                    Información personal y cargas registradas
                                </span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="text-center">
                        <Col xs={12}>
                            <span id="divvalidacion" className="rojo"> <strong> Su carga familiar se encuentra en etapa de validación en Talento Humano </strong> </span>
                        </Col>
                    </Row>
                    <Row>
                        <div className="table-responsive containertablaDetalleMarcaciones">
                            <Table bordered className="tableMarcacionesDetalle tableHistorialSolicitudesVacaciones" >
                                <thead className="cabecerasDetallehistorialSolic">
                                    <tr className="" >
                                        <th> Información extraida del sistema de talento humano - datos personales</th>
                                        <th> Discapacidad - enfermedad catastrofica, rara o huérfana</th>
                                        <th> Documento habilitante</th>
                                        <th> Información validada por TH</th>
                                        <th> Considerar para rebaja en el formulario de gastos personales</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.CargasList.length == 0 ?
                                            <> <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleES999"}>
                                                <td colSpan={5} className="text-center"> No existe información para mostrar </td>
                                            </tr> </>
                                            : 
                                        this.state.CargasList.map((infoDetalle, indiceinfoDetalle) => {
                                            return (
                                                <>
                                                <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleES" + indiceinfoDetalle}>
                                                    <td>
                                                        {infoDetalle.apellidos + " " + infoDetalle.nombres}
                                                    </td>
                                                    <td>
                                                        {(infoDetalle.tieneenfercatastrofica && infoDetalle.tieneenfercatastrofica === "S") || (infoDetalle.esincapacitado && infoDetalle.esincapacitado === "S") ? "SI" : "NO"}
                                                    </td>
                                                    <td>
                                                        {((infoDetalle.tieneenfercatastrofica && infoDetalle.tieneenfercatastrofica === "S" && infoDetalle.refarchivoenfercatastrofica) ? "SI" : " ")}
                                                        {((infoDetalle.idparentesco == 1 || infoDetalle.idparentesco == 2) ? (infoDetalle.refarchivoconsentimiento ? "SI" : "Presentar documento habilitante para este año") : " ")}
                                                    </td>
                                                    <td>
                                                        {infoDetalle.estadorevisionth === "S" ? "SI" : "NO"}
                                                    </td>
                                                    <td>
                                                        <div className="row ml-1" >
                                                            <CustomInput
                                                                className="col-md-5"
                                                                type="radio"
                                                                value="S"
                                                                id={"considerars_" + indiceinfoDetalle}
                                                                key={"keys" + indiceinfoDetalle}
                                                                name={"strconsiderar" + indiceinfoDetalle}
                                                                //checked={infoDetalle.strconsiderar && infoDetalle.strconsiderar === "S"}
                                                                onChange={e => this.handleChange2(e, indiceinfoDetalle)}
                                                                label="Sí"
                                                            />
                                                            <CustomInput
                                                                className="col-md-6"
                                                                type="radio"
                                                                value="N"
                                                                id={"considerarn_" + indiceinfoDetalle}
                                                                key={"keyn" + indiceinfoDetalle}
                                                                name={"strconsiderar" + indiceinfoDetalle}
                                                                //checked={infoDetalle.strconsiderar === null || infoDetalle.strconsiderar === "N"}
                                                                onChange={e => this.handleChange2(e, indiceinfoDetalle)}
                                                                label="No"
                                                            />
                                                        </div>
                                                    </td>

                                                </tr>
                                                </>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                    <Row>
                        <Col xs={12} className="text-center">
                            <Button id="btnvalidacion" className="secondary" type="button" style={{ float: 'inherit' }} onClick={() => this.onClickAceptarCargas()}>Enviar a validación de TH</Button>
                            <Button id="btncontinuar" className="secondary" type="button" style={{ float: 'inherit' }} onClick={() => this.toggleConfirmacion()}>Continuar con el formulario de gastos personales</Button>
                        </Col>
                    </Row>
                    <Row>
                        <div className="text-center">
                            {MensajeValidacionCargas}
                        </div>
                    </Row>
                    <Row>
                        <div className="text-center">
                            {MensajePopup}
                        </div>
                    </Row>

                </div>
            </React.Fragment>
        )
    }

    onClickAceptarCargas() {
        var dto = this.state.CargasList;

        const data = JSON.stringify({
            "entidad": dto,
        });

        fetch(API_URL + "FormularioGastosPersonales/PostCargasRegistradass", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: data,
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(" " + responseJson["strMensaje"])
                    }
                    else if (responseJson["strEstado"] === "S") {
                        alertService.success("La información de las cargas ha sido enviada a TH, una vez validada, podrá continuar con el registro del formulario.");
                    }
                    else {
                        alertService.error(" " + responseJson)
                    }

                    this.setState({
                        isOpenModal: false
                    });
                },
                (error) => {
                    alertService.error("Ha ocurrido un evento inesperado: " + error);
                })
    }

    vistPreviaAplicarDescuento() {

        let institucion = "";
        this.state.GastosPersonalesList.map((dto, indice) => {
            if (dto["descripcion"].includes("APLICARME DESCUENTO") && dto["valor"] === "1") {
                institucion = dto["comentario"];
            };
        });

        if (institucion === "") {
            alertService.error("Ingrese el nombre de la institución con la que tiene relación de dependencia.");
            return;
        }

        const data = JSON.stringify({
            "idpersona": this.state.currentUser.idpersona,
            "institucion": institucion,
        }); 

        //fetch(API_URL + "FormularioGastosPersonales/VistaPreviaAplicarDescuento/" + this.state.currentUser.idpersona, {
        fetch(API_URL + "FormularioGastosPersonales/VistaPreviaAplicarDescuento/", {

            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: data,
        })
            .then(response => {
                response.blob()
                    .then(blob => {
                        let url = window.URL.createObjectURL(blob);

                        this.setState({ urlAplicarDescuento: url, showModalAplicarDescuento: true });

                    });
            }
            )
    }

    public render() {
        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : (!tieneRestriccion) ? <div>LO SENTIMOS, NO PUEDE REALIZAR ACCIONES EN ESTA SECCIÓN</div> : this.renderForm(this.state.FormularioGastosPersonalesList, this.state.tipoSolicitudList, this.state.GastosPersonalesList, this.state.tiposEvidencia, this.state.dtoFechas);
        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(FormularioGastosPersonalesList: Array<any>, tipoSolicitudList: Array<any>, GastosPersonalesList: Array<any>, tiposEvidencia: Array<any>, fechas: FormularioGastosPersonalesFechas) {
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Formulario de Gastos Personales</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div className={"new-alert-warn mb-1"}>
                                    <div>
                                        <img src={Megafono} className="icono_imagen " />&nbsp;{MensajeEncabezado} <br /> {MensajeEncabezado2}
                                    </div>
                                </div>
                                <div>
                                    <br />
                                    {(new Date()).getTime() < (new Date(fechas.fechahasta + "T23:59:59")).getTime() ?
                                        <form onSubmit={this.handleSave}>
                                            <Row>
                                                <Col md={2}>
                                                    <Button color="secondary" type="button" className="btn btn-default" style={{ float: "left" }} onClick={() => this.showModal()}>Nuevo Formulario</Button>
                                                </Col>
                                                <Col md={3}>
                                                    <a href="https://talentohumano.espol.edu.ec/Sitio/archivos/GUI-DHO-009_Guia_para_llenado_de_proyeccion_de_gastos_personales.pdf" target="_blank">
                                                        <Button color="secondary" type="button" className="btn btn-default" style={{ float: "left" }}>Guía</Button>
                                                    </a>
                                                </Col>
                                            </Row>

                                            <Row id="row1" style={this.state.showDiv ? {} : { display: 'none' }}>
                                                <Col md={12}>
                                                    <Table id="TableI" bordered striped>
                                                        <thead style={{ background: "#517DD2", color: "white" }}>
                                                            <tr>
                                                                <th style={{ width: "40%" }}>INGRESOS GRABADOS PROYECTADOS</th>
                                                                <th style={{ width: "20%" }}>Valor</th>
                                                                <th style={{ width: "40%" }}>Observación</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {GastosPersonalesList.map((fila, index) => {
                                                                return (
                                                                    (fila.tipo == "I" || fila.tipo == "0") ?
                                                                        <tr key={"row" + fila.secuencia} className="rows_tabla_planificacion_vac">
                                                                            <td className={fila.tipo == "0" ? "celeste" : ""} style={{ textAlign: fila.tipo == "0" ? "right" : "left" }}> {fila.descripcion} </td>
                                                                            <td> <Input className="row_gastos_personales" readOnly={fila.tipo == "I" ? !fila.descripcion.includes("ESTE EMPLEADOR") ? false : true : true} type="text" name="valor" id={"montoI_" + index} placeholder="" value={fila.valor} onChange={e => this.handleInputChange(e, fila.secuencia)} autoComplete="off" />  </td>
                                                                            <td style={{ textAlign: "left" }}> {fila.detalleitem} </td>
                                                                        </tr> :
                                                                        (fila.tipo == "3") ?
                                                                            <tr key={"row" + fila.secuencia} className="rows_tabla_planificacion_vac hide" id={"row_aplicadescuento"}>
                                                                                <td style={{ textAlign: "left" }}> {fila.descripcion} </td>
                                                                                <td> <div className="row ml-1" >
                                                                                    <CustomInput
                                                                                        className="col-md-5"
                                                                                        type="radio"
                                                                                        value="0"
                                                                                        id="aplicardescuento_si"
                                                                                        name="aplicardescuento"
                                                                                        onChange={e => this.handleChange3(e, fila.secuencia)}
                                                                                        label="Sí"
                                                                                        disabled
                                                                                    />
                                                                                    <CustomInput
                                                                                        className="col-md-6"
                                                                                        type="radio"
                                                                                        value="1"
                                                                                        id="aplicardescuento_no"
                                                                                        name="aplicardescuento"
                                                                                        onChange={e => this.handleChange3(e, fila.secuencia)}
                                                                                        label="No"
                                                                                        disabled
                                                                                    />
                                                                                </div> </td>
                                                                                <td> <Input className="row_gastos_personales" disabled={true} type="text" name="valor" id="txtaplicardescuento" placeholder="Ingrese el nombre de la institución" value={fila.comentario??""} onChange={e => this.handleChange4(e, fila.secuencia)} autoComplete="off" maxLength="125" />
                                                                                    <Button id="btnpreviewaplicardescuento" color="primary" type="button" className="btn btn-sm btn-default hide" style={{ float: "right" }} onClick={() => this.vistPreviaAplicarDescuento()}>Vista previa carta para no aplicar descuento</Button>
                                                                                </td>
                                                                            </tr>
                                                                            :
                                                                        <tr key={"row" + index} className="hide">
                                                                            <td>  </td>
                                                                            <td>  </td>
                                                                            <td>  </td>
                                                                        </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row id="row2" style={this.state.showDiv ? {} : { display: 'none' }}>
                                                <Col md={12}>
                                                    <Table id="TableE" bordered striped>
                                                        <thead style={{ background: "#517DD2", color: "white" }}>
                                                            <tr>
                                                                <th style={{ width: "40%" }}>GASTOS PROYECTADOS</th>
                                                                <th style={{ width: "20%" }}>Valor</th>
                                                                <th style={{ width: "40%" }}>Observación</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                GastosPersonalesList.map((fila, index) => {
                                                                    return (
                                                                        (fila.tipo == "G" || fila.tipo == "1") ?
                                                                            <tr key={"row" + fila.secuencia} className="rows_tabla_planificacion_vac">
                                                                                <td className={fila.tipo == "1" ? "celeste" : ""} style={{ textAlign: fila.tipo == "1" ? "right" : "left" }}> {fila.descripcion} </td>
                                                                                <td> <Input className="row_gastos_personales" readOnly={fila.tipo == "G" ? false : true} type="text" step="0.01" min="0" name="valor" id={"montoG_" + index} placeholder="" value={fila.valor} onChange={e => this.handleInputChange(e, fila.secuencia)} autoComplete="off" /> </td>
                                                                                <td style={{ textAlign: "left" }}> {fila.tipo == "1" ? GastosPersonalesList.map((fila2, index2) => { return (fila2.descripcion == "MÁXIMO DE GASTOS PERSONALES DEDUCIBLES" ? "MÁXIMO DE GASTOS PERSONALES DEDUCIBLES  " + fila2.valor : "") }) : fila.detalleitem} </td>
                                                                            </tr> :
                                                                            <tr key={"row" + index} className="hide">
                                                                                <td>  </td>
                                                                                <td>  </td>
                                                                                <td>  </td>
                                                                            </tr>
                                                                    )
                                                                })}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row id="row4" style={this.state.showDiv ? {} : { display: 'none' }}>
                                                <Col md={12}>
                                                    <Table id="TableR" bordered striped>
                                                        <thead style={{ background: "#517DD2", color: "white" }}>
                                                            <tr>
                                                                <th style={{ width: "40%" }}>REBAJA POR GASTOS PERSONALES</th>
                                                                <th style={{ width: "20%" }}>Valor</th>
                                                                <th style={{ width: "40%" }}>Observación</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {GastosPersonalesList.map((fila, index) => {
                                                                return (
                                                                    (fila.tipo == "R" || fila.tipo == "2") ?
                                                                        <tr key={"row" + fila.secuencia} className="rows_tabla_planificacion_vac">
                                                                            <td className={fila.tipo == "2" ? "celeste" : ""} style={{ textAlign: fila.tipo == "2" ? "right" : "left" }}> {fila.descripcion} </td>
                                                                            <td> <Input className="row_gastos_personales" readOnly={true} type="text" name="valor" id={"montoR_" + index} placeholder="" value={fila.valor} onChange={e => this.handleInputChange(e, fila.secuencia)} autoComplete="off" /> </td>
                                                                            <td style={{ textAlign: "left" }}> {fila.detalleitem} </td>
                                                                        </tr> :
                                                                        <tr key={"row" + index} className="hide">
                                                                            <td>  </td>
                                                                            <td>  </td>
                                                                            <td>  </td>
                                                                        </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                            <Row id="row3" form style={this.state.showDiv ? {} : { display: 'none' }}>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Button id="btncancelar" color="secondary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickCancelar()}>Cancelar</Button>
                                                        <Button id="btnaceptar" color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickAceptar()}>Aceptar y Enviar</Button>
                                                        <Button id="btnguardar" color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <br />
                                        </form>
                                        : ('')}
                                </div>
                                <br />
                                <div style={{ marginTop: "15px" }}>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {FormularioGastosPersonalesList.map((dto, index) =>
                                                <CardFormularioGastosPersonales
                                                    key={dto.idotrosdocumentos}
                                                    objeto={dto}
                                                    objetofechas={this.state.dtoFechas}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + FormularioGastosPersonalesList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idgastopersonalcab)}
                                                    eventDelete={() => this.onClickDelete(dto.idgastopersonalcab)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <ModalConfirmacion
                    show={this.state.isOpenModal}
                    asyncAccion={false}
                    asyncClose={false}
                    closeAfterAccion={false}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={""}
                    nombreBotonAccion={"Cerrar"}
                    nombreBotonCerrarModal={"Cancelar"}
                    onClose={() => this.setState({ isOpenModal: false })}
                    size={"xl"}
                    classNameContentModal={"contentModalAprSolReintegroVacaciones"}
                    contentModal={this.mostrarSeccionCargas()}
                    classNameBotonCerrarModal={{ position: "absolute", zIndex: 9999, marginLeft: "40%" }}
                    tituloModal={"Registro(s) de carga(s) familiar(es) para gastos personales"}
                    classNameAllModal={""}
                />

                <Modal isOpen={this.state.isOpenConfirmacion} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea continuar con el registro del formulario de gastos personales?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.onClickLimpiar()}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>

                <Modal isOpen={this.state.showModalAplicarDescuento} fade={false} size="lg" >
                    <ModalHeader>
                        <b>La carta se genera una vez que de click en "Aceptar y Enviar"</b>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                        </Row>
                        <PDFViewer url={this.state.urlAplicarDescuento} heightValue={ "500px" } />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleAplicarDescuento}>Aceptar</Button>{' '}
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default FormularioGastosPersonales;